/**
 * Canonical list of user-preference keys synced to the DB via app_settings.
 * Anything NOT in this list stays local — caches (app-orders-cache, chart bars,
 * react-query's persisted state) and the auth bag.
 *
 * Keys here also drive the one-time localStorage → DB migration when
 * useSettingsStore.hydrate() first sees a clean DB row for a given key.
 */
export const SYNCED_SETTINGS_KEYS = [
  // Quick-trade & order ticket
  'quick-trade-enabled',
  'order-type-mode',
  'default-quick-trade-mode',
  'quick-trade-mode',
  'quick-trade-qty',
  'quick-trade-pct',
  'quick-trade-amt',
  // Options ticket
  'option-trade-mode',
  'option-trade-qty',
  'option-trade-pct',
  'option-trade-amt',
  'option-show-chain',
  'option-strikes-each',
  // Ticker page
  'default-ticker-tab',
  'ticker-trade-panel-minimized',
  // Risk gates
  'max-closed-positions-per-day',
  'max-loss-per-day',
  'max-gain-per-day',
  // Cutoffs
  'options-cutoff-time',
  'opening-cutoff-time',
  // Rules
  'orb-block-enabled',
  'trend-block-enabled',
  'trend-strength-config',
  // Chart
  'ticker-chart-indicators',
  // Misc stores
  'public-trading-privacy',
  'pta_recent_tickers',
] as const

export type SyncedSettingsKey = (typeof SYNCED_SETTINGS_KEYS)[number]
